import type {PageBackgroundObject} from '@PosterWhiteboard/page/page-background.class';
import type * as Fabric from '@postermywall/fabricjs-2';
import type {PageItemsObject} from '@PosterWhiteboard/page/page-items.class';
import type {UpdateFromObjectOpts} from '@PosterWhiteboard/common.types';
import type {AudioClipsObject} from '@PosterWhiteboard/classes/audio-clips/audio-clips.class';

import type {ColorPaletteInfo} from '@Libraries/color-palettes.library';

export const PAGE_OPTIONS_WIDTH = 34;
export const MAX_ALLOWED_GRAPHIC_ITEMS = 300;
export const PAGE_SLIDER_CONTAINER_HEIGHT = 14;

export interface PageModifiedEvent {
  firePosterModifiedEvent: boolean;
}

export interface PageEvents {
  modified: PageModifiedEvent;
  'time:updated': number;
  'playback:ended': void;
  seek: number;
}

export interface ToDataURLOpts {
  maxDimension?: number;
  width?: number;
  height?: number;
}

export interface PageUpdateFromObjectOpts extends UpdateFromObjectOpts {
  firePosterModifiedEvent?: boolean;
}

export interface TemplateDataObject {
  posterId: string;
  pageId: string;
}
export interface GalleryTemplateDataObject {
  posterId: string;
  pageId: string;
  idGalleryTemplateCreator?: number;
}

export interface PageObject {
  hashedID: string;
  items: PageItemsObject;
  audioClips: AudioClipsObject;
  background: PageBackgroundObject;
  duration: number;
  isCustomDuration: boolean;
  zoom: number;
  isPlaying: boolean;
  templateData?: TemplateDataObject;
  galleryTemplateData?: GalleryTemplateDataObject;
  currentTime: number;
  appliedPalette?: ColorPaletteInfo;
  lastModified: Date;
}

export const CANVAS_BACKDROP_CLASS = 'pmw-canvas-backdrop';
export const ACTIVE_PAGE_FLASH_CLASS = 'pmw-page-active-flash';

export interface ContextMenuStoppedEventData {
  e: MouseEvent;
  target: Fabric.Object | undefined;
}

export const DEFAULT_BACKGROUND_COLOR = 'ffffff';
export const DEFAULT_SECONDARY_BACKGROUND_COLOR = '000000';
export const MAX_ITEM_ANIMATION_DELAY_FACTOR = 0.3; // Remember to change its counter part in php postervo variable value too
export const MAX_ANIMATION_DURATION = 4;
export const FIXED_SEQUENTIAL_ANIMATION_DELAY_FACTOR = 0.4;
export const MAX_ITEMS_WITH_FIXED_DELAY_FACTOR = 5;
export const GUIDELINES_COLOR = '#FF5177';
export const GUIDELINES_MARGIN = 3;
